<template>

  <b-modal
      :id="id"
      ref="modal"
      :title="title"
      cancel-title="Cancelar"
      @show="onShow"
      @hidden="onHidden"
      @ok="handleOk">

    <validation-observer ref="validation">

      <b-form @submit.prevent="onSubmit" ref="form">

        <t-form-wrapped :command="command" :status="onStatus">
          <slot></slot>
        </t-form-wrapped>

      </b-form>

    </validation-observer>

    <template #modal-footer="{ ok, cancel }">

      <t-button @click="cancel()" text="Cancelar" :sending="onSending" secondary/>
      <t-button @click="ok()" :text="okText" :sending="onSending" primary/>

    </template>

  </b-modal>

</template>
<script>
export default {
  name: 't-dialog-confirm',
  data() {
    return {
      status: "",
    }
  },
  props: {
    id: String,
    title: String,
    okText: {
      type: String,
      default: 'Excluir'
    },
    command: {
      type: String,
      default: 'insert'
    },
  },
  computed: {
    onStatus() {
      return this.status
    },
    onSending() {
      return this.status === "sending"
    },
  },
  methods: {

    onShow() {
      this.$emit('show')
    },
    onHidden() {
      this.$emit('hidden')
    },
    handleOk(bvModalEvt) {

      bvModalEvt.preventDefault()
      this.onSubmit()

    },
    onSubmit() {


        this.$emit('onSubmit')

    }


  }
}
</script>
